module.exports = __webpack_public_path__ + "b7369ec74cd2a2ccf698ab0416ba2711.svg";